<template>
  <div class="uupay-container">

    <section class="modules-section">
      <div class="container">
        <div class="content my-4">
          <div class="row">
            <div class="col-md-12">
              <router-link to="/blog">
                <div class="back d-flex align-items-center">
                  <div class="mr-2"><img src="@/assets/uupay/icon/svg/wonder_blog_arrow_left.svg" class="img-fluid"></div>
                  <div>返回網誌</div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="content my-4">
          <div class="row">
            <!-- 左侧内容区域 -->
            <div class="col-md-9">
              <div class="blog-content" ref="content">
                <h1 class="title mb-5 pb-3">{{ blog.title }}</h1>
                <el-divider></el-divider>
                <div class="d-flex justify-content-between my-5">
                  <div>
                    <div class="uupay mb-3">UUPay</div>
                    <div class="date">{{ blog.date }}</div>
                  </div>
                  <div class="d-flex align-items-end">
                    <div class="mr-5"><img src="@/assets/uupay/icon/svg/blog_detail_facebook.svg" alt="" class="img-fluid"></div>
                    <div class="mr-5"><img src="@/assets/uupay/icon/svg/blog_detail_x.svg" alt="" class="img-fluid"></div>
                    <div><img src="@/assets/uupay/icon/svg/blog_detail_ins.svg" alt="" class="img-fluid"></div>
                  </div>
                </div>
                
                <!-- <div v-for="section in sections" :key="section.id" :id="'section-'+section.id">
                  <div v-if="section.imgUrl" class="my-5">
                    <img :src="section.imgUrl" alt="" class="img-fluid">
                  </div>
                  <h2 >{{ section.title }}</h2>
                  <div v-html="section.content"></div>
                </div> -->
                <div class="section-content">
                  <div v-html="paragraph"></div>
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <!-- 右侧导航区域 -->
              <div class="blog-navigation">
                <div class="navigation-line"></div>
                <div 
                  v-for="section in sections" 
                  :key="section.id"
                  class="nav-item"
                  :class="{ active: activeSection === section.id }"
                  @click="scrollToSection(section.id)"
                >
                  <div class="nav-indicator"></div>
                  <span>{{ section.title }}</span>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>

    </section>
    
  </div>
</template>
<script>
import BlogCard from "@/components/BlogCard";

export default {
  name: 'BlogDetail',
  components: {
    BlogCard
  },
  data() {
    return {
      blog: {
        title: '中小企必看｜Digital 2025香港報告出爐！超過8成港人活躍於社交平台 附實用營商建議',
        date: '31 March 2025',
      },
      sections: [
        { id: 1, title: '引言' },
        { id: 2, title: '分段标题1' },
        { id: 3, title: '分段标题2' },
        { id: 4, title: '結語' },
        // { id: 1, title: '组件通信', content: '...详细内容...', imgUrl: require('@/assets/uupay/images/blog_detail_1.png') },
        // { id: 2, title: '状态管理', content: '...详细内容...', imgUrl: require('@/assets/uupay/images/blog_detail_1.png') },
        // { id: 3, title: '性能优化', content: '...详细内容...', imgUrl: require('@/assets/uupay/images/blog_detail_1.png') },
        // { id: 4, title: '路由管理', content: '...详细内容...', imgUrl: require('@/assets/uupay/images/blog_detail_1.png') }
      ],
      activeSection: 1,
      observer: null,
      paragraph: `<div class="my-5 pt-4">
                    <div>
                      <img src="/static/blog_detail_1.png" alt="" class="img-fluid">
                    </div>
                    <div class="my-5 abstract">
                      最新的Digital 2025 香港版報告帶來了最全面的數碼趨勢分析，作為中小企、網店店主或從事營銷行業的你就一定要知道！
                    </div>
                  </div>
                  <div id="section-1">
                    <h2>引言</h2>
                    <p>。。。這是引言。。。</p>
                  </div>
                  <div id="section-2">
                    <h2>分段标题1</h2>
                    <p>（分段正文）隨著數碼科技的迅速發展，消費者的行為模式和企業與潛在客戶連接的方式正在逐漸改變。最新的Digital 2025 香港版報告帶來了最全面的數碼趨勢分析，涵蓋了社交平台、搜尋結果及電子商務等重要數據。本文將會為大家整合剖析報告中的重點數據，提供切實可行的營銷建議，助你在2025年搶佔先機，推動業務增長！</p>
                  </div>
                  <div class="my-5"><img src="/static/blog_detail_2.png" alt="" class="img-fluid"></div>
                  <div id="section-3">
                    <h2>分段标题2</h2>
                    <p>（分段正文）在香港的數碼通訊生態中，WhatsApp已成為不可或缺的核心平台。它不僅是最受歡迎的即時通訊工具，更已深深融入香港人的日常生活和社交習慣。對於商戶而言，WhatsApp也代表著一個直接、高效且具有巨大潛力的客戶互動渠道，以建立更緊密、更個性化的客戶關係。</p>

                    <p>KConnect為商戶提供一站式營運管理平台，結合WATI專業WhatsApp Business API服務，為商戶打造全面的客戶互動解決方案。服務涵蓋自動回覆、群發訊息、客戶分群等功能，使商戶能輕鬆管理大量客戶對話，提供24/7自動化客戶支援。系統還能根據客戶行為發送個性化營銷訊息，展示完整產品目錄，並通過KPay的支付功能，讓客戶直接在WhatsApp對話中完成交易。</p>

                    <p>例如，透過WhatsApp Business API結合KPay收款連結功能，商戶可以設置自動聊天機器人回答客戶問題、提供產品目錄，並在客戶決定購買時直接發送支付連結完成交易。這種整合不僅提高了便利性，還能創造更流暢的購物體驗，從諮詢到購買實現無縫轉換，大大縮短了轉化時間。通過WhatsApp，商戶還可以發送訂單確認、發貨通知，甚至提供個性化的產品推薦，從而增強客戶忠誠度。</p>
                  </div>
                  <div id="section-4">
                    <h2>結語</h2>
                    <p>。。。這是結語。。。</p>
                  </div>
                 `,
    }
  },
  mounted() {
    console.log('router params:', this.$route.params.id)
    // for (let section of this.sections) {
    //   section.content = this.paragraph
    // }
    // 在滚动事件中调用
    window.addEventListener('scroll', this.checkActiveSection)
  },
  methods: {
    // 示例：跳转到指定幻灯片
    goToSlide(index) {
      this.$refs.banner.slideTo(index)
    },
    
    // 示例：暂停自动播放
    pauseBanner() {
      this.$refs.banner.stopAutoplay()
    },
    
    // 示例：恢复自动播放
    resumeBanner() {
      this.$refs.banner.startAutoplay()
    },
    handleKind(index) {
      this.activeIndex = index
    },
    handlePageChange(page) {
      console.log('handlePageChange:', page)
    },
    checkActiveSection() {
      const triggerPos = window.innerHeight * 0.5 // 视口中线
      
      this.sections.forEach(section => {
        const element = document.getElementById(`section-${section.id}`)
        if (element) {
          const rect = element.getBoundingClientRect()
          // 元素顶部在视口中线以上，且底部在视口中线以下
          if (rect.top <= triggerPos && rect.bottom > triggerPos) {
            this.activeSection = section.id
          }
        }
      })
    },
    scrollToSection(sectionId) {
      const element = document.getElementById(`section-${sectionId}`)
      this.activeSection = parseInt(sectionId)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    },
  },
  
}
</script>
<style scoped>


.modules-section {
  padding: 2rem 0;
  color: #21042e;
  background-color: #fff;
  border-top: 1px solid #e9e9e9;
  margin-bottom: 2rem;
}

.modules-section .back {
  font-size: 20px;
  line-height: 100%;
  font-weight: 500;
  margin: 1.2rem 0;
  color: #21042e;
  cursor: pointer;
}
.modules-section .title {
  font-size: 40px;
  line-height: 100%;
  font-weight: 600;
  margin: 1.2rem 0;
  color: #21042e;
}

@media (min-width: 1700px) {
  .modules-section-container {
    max-width: 1440px;
  }
}

@media (min-width: 1280px) {
  .modules-section .content {
    margin: 0 3rem;
  }
}

.uupay {
  font-size: 24px;
  font-weight: 600;
  color: #21042e;
}
.date {
  font-size: 20px;
  font-weight: 400;
  color: #898989;
}


.blog-content {
  flex: 1;
  /*padding-right: 40px;*/
}

.blog-navigation {
  /*width: 250px;*/
  height: 100%;
  position: sticky;
  /*position: fixed;*/
  top: 20px;
  align-self: flex-start;
  padding-left: 20px;
}

.navigation-line {
  position: absolute;
  /*left: 7px;*/
  top: 0;
  bottom: 0;
  width: 2px;
  background-color: #e9e9e9;
  margin-top: 7px;
}

.nav-item {
  position: relative;
  padding: 8px 0 8px 20px;
  cursor: pointer;
  color: #c1c1c1;
  transition: all 0.3s;
  font-size: 20px;
  font-weight: 500;
  line-height: 30px;
}

.nav-item:hover {
  color: auto;
}

.nav-indicator {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 16px;
  background-color: transparent;
  transition: all 0.3s;
}

.nav-item.active {
  color: #21042e;
  font-weight: bold;
}

.nav-item.active .nav-indicator {
  background-color: #9a307a;
  height: 30px;
}

.blog-content h2 {
  font-size: 30px;
  font-weight: 500;
  margin: 2rem 0;
  color: #21042e;
}
.blog-content p {
  font-size: 24px;
  font-weight: 500;
  color: #21042e;
}
.blog-content img {
  width: 100%;
}

.paragraph {
  font-size: 24px;
  font-weight: 400;
}

@media (max-width: 768px) {
  .blog-detail-container {
    flex-direction: column;
  }
  .blog-navigation {
    width: 100%;
    position: static;
    margin-top: 40px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/BlogDetail.vue